export default __webpack_public_path__ + "static/media/bamboomantra.551a80e5.mp3";